import { useStore } from "../state/store";

export function LocaleSwitcher() {
  const languages = useStore((s) => s.project.languages);
  const activeLocale = useStore((s) => s.ui.activeLocale);
  const setActiveLocale = useStore((s) => s.setActiveLocale);

  if (languages.length <= 1) return null;
  return (
    <div className="locale-switcher">
      <span>Editing language:</span>
      <select value={activeLocale} onChange={(e) => setActiveLocale(e.target.value)}>
        {languages.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label} ({l.code})
          </option>
        ))}
      </select>
    </div>
  );
}
